import { render } from "./request-password-reset-confirmation-component.vue?vue&type=template&id=041431c8"
const script = {}

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__